"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return typeof value === 'symbol' || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Symbol]';
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isSymbol.js
// module id = 2151
// module chunks = 0